import React from 'react'
import PropTypes from 'prop-types'
import { default as SVGSpinner } from 'react-svg-spinner'

const SIZES = {
  small: '16px',
  medium: '24',
  large: '40px',
}

export default function Spinner({ size = 'medium', thickness = 2, ...props }) {
  if (SIZES[size]) {
    return <SVGSpinner size={SIZES[size]} thickness={thickness} {...props} />
  } else {
    return <SVGSpinner size={size} thickness={thickness} {...props} />
  }
}

Spinner.propTypes = {
  size: PropTypes.string,
  thickness: PropTypes.number,
}



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js